import { createSelector } from 'reselect';
import { PageContext, PageMode } from '../../web/containers/BlockPage/consts';

export const allPagesSelector = (state) => state.BlockPageUI.get('pages');

export const allPageUIById = createSelector(
  [allPagesSelector],
  (pages) => pages
);

export const selectBlockPageIsEditing = createSelector(
  [allPageUIById],
  (allPageUIs) =>
    allPageUIs.filter(
      (pageUI) =>
        pageUI.get('viewedFrom') === PageContext.BLOCKPAGE &&
        pageUI.get('mode') === PageMode.EDIT
    ).size > 0
);
